import CoreRelatedPractices from './CoreRelatedPractices';

export { type CoreRelatedPracticesProps } from './CoreRelatedPractices';
export default CoreRelatedPractices;
